import assign from 'lodash/assign';
import map from 'lodash/map';

import {
  TYPE_PERSONNE
} from '../../model';

import {
  allPrevSteps
} from '../../../../utils/routes.util';

require('./menu.scss');

export default function MenuComponent() {
  return {
    controller: MenuController,
    template: require('./menu.html')
  };
}

// @ngInject
class MenuController {
  constructor($scope, $ngRedux, $state) {
    this.$scope = $scope;
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.steps = [];
  }

  $onInit() {
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          demande: state.demande.data
        };
      }
    )(selectedState => {
      assign(this, selectedState);
      this.steps = map(allPrevSteps(this.demande, this.$state.current.name).reverse(), s => {
        if (s !== 'home') {
          return this.$state.get(s);
        }
        let res = this.$state.get(s);
        res.data.label = this.computeHomeLabel(this.demande.typePersonne);
        return res;
      });
      this.onlyHome = this.steps.length <= 1;
    });
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }
  computeHomeLabel(typePersonne) {
    switch (typePersonne) {
    case TYPE_PERSONNE.PROFESSIONNEL_RECEPTION:
      return 'Antenniste';
    case TYPE_PERSONNE.SYNDIC_BAILLEUR:
      return 'Syndic ou bailleur';
    case TYPE_PERSONNE.PARTICULIER:
      return 'Particulier';
    default:
      return 'Accueil';
  }
  }
}



// WEBPACK FOOTER //
// ./src/modules/base/components/menu/menu.component.js